import { useMemo } from "react"
import { TableVisualization } from "~/ui-rtk/components/ui/charts"
import ChartLoader from "~/ui-rtk/components/ui/charts/ChartLoader"
import TableFiltersBar from "~/ui-rtk/components/ui/controls/FiltersBar/TableFiltersBar"
import {
  AggregationType,
  VISUALIZATION_TYPE,
  VISUALIZATIONS_MAP,
  type VISUALIZATIONS_MAP_KEY,
} from "~/ui-rtk/constants/charts"
import useSources from "~/ui-rtk/hooks/sources"

export const TABLE_WIDGETS = {
  THEME: "mentions_by_theme_table",
  METATHEME: "mentions_by_metatheme_table",
  BUYING_OCCASION: "mentions_by_buying_occasion_table",
  CATEGORY: "mentions_by_category_table",
}

export default function MentionsAnalysisTable({
  granularity,
  dateRange,
  compareRange,
  widget,
}: {
  granularity: AggregationType
  dateRange: [Date, Date]
  compareRange?: [Date, Date]
  widget: VISUALIZATIONS_MAP_KEY
}) {
  const { sources } = useSources()
  const visualization = useMemo(() => VISUALIZATIONS_MAP[widget], [widget])

  return (
    <div
      role="region"
      aria-label={`Mentions analysis table: ${visualization?.name ?? widget}`}
    >
      <TableFiltersBar
        id={widget}
        className="h-12"
        columnConfig={visualization?.props?.columnConfig}
        additionalFilters={visualization?.props?.additionalFilters}
      />
      <div className="mt-system-lg">
        <ChartLoader
          {...visualization?.props}
          chartId={widget}
          widgetType={VISUALIZATION_TYPE.TableVisualization}
          component={TableVisualization}
          dateRange={dateRange}
          compareRange={compareRange ?? undefined}
          granularity={granularity}
          sources={sources}
          hideAggSelector={true}
          disableGranularity={true}
          requiredSources={visualization?.requiredSources}
          cubeQueryParams={{
            [widget]: {},
          }}
          description={visualization?.description ?? undefined}
          compareMode={
            visualization?.props?.comparisonEnabled &&
            (compareRange?.length ?? 0) > 0
          }
        />
      </div>
    </div>
  )
}
